<mat-card class="card-general">
  <mat-card-title>Archivos de prescripción</mat-card-title>
  <mat-card-content>
    <div class="d-flex flex-column flex-md-row gap-3" *ngIf="prescriptionsResponse.length != 0">
      <button type="button" *ngFor="let item of prescriptionsResponse" (click)="downloadPrescription(item.path)" class="button secondary-button">
        <span style=" white-space: normal;">
          Prescripción etapa #{{item.stageNumber}}
        </span>
      </button>
    </div>
    <div class="d-flex" *ngIf="prescriptionsResponse.length == 0">
      <p>¡Aún no hay archivos de prescripción creados!</p>
    </div>
  </mat-card-content>
</mat-card>
